import React from 'react';

const UserScreenerFormModal = React.lazy(() => import('../components/FormModal'));
const userScreenerModalRegistry = {
    personalize_userScreenerId: UserScreenerFormModal
};
export default userScreenerModalRegistry;
